// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

var defaultValue = {
  country: {
    TAG: /* India */1,
    _0: {
      time_zone: "Asia/Kolkata",
      currency: "\xe2\x82\xb9",
      iso_code: "INR",
      mobile_validation_regex: "^[6-9]{1}[0-9]{9}$"
    }
  }
};

var context = React.createContext(defaultValue);

function useContext(param) {
  return React.useContext(context);
}

export {
  defaultValue ,
  context ,
  useContext ,
  
}
/* context Not a pure module */
